function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var CDNPREFIX = '//d3qrssutfqv0j9.cloudfront.net';
export var cdn = function cdn(path) {
  return "".concat(CDNPREFIX).concat(path);
};
export var cdnRetryList = ['https://cdn-static.kwai.net', 'https://cdn-static.ap4r.com', 'https://aws-static.ap4r.com', 'https://g-static.ap4r.com']; // 比如它链接本身就是https://cdn-static.ap4r.com,你从这个位置为第一项去向下遍历

export var getCdnRetryList = function getCdnRetryList(url) {
  var origin = new URL(url).origin;
  var index = cdnRetryList.findIndex(function (item) {
    return item === origin;
  });

  if (index === -1) {
    return cdnRetryList;
  }

  return [].concat(_toConsumableArray(cdnRetryList.slice(index)), _toConsumableArray(cdnRetryList.slice(0, index)));
};
export var getCdnImg = function getCdnImg(arr) {
  if (!arr) {
    return '';
  }

  if (typeof arr === 'string') {
    return arr;
  }

  if (arr[0] && arr[0].url) {
    return arr[0].url;
  }

  return '';
};